import { Observable, Subscriber } from 'rxjs';
import { execIfDefined } from '../../core/utils/exec-if-defined';
import { AppConfig } from '../../core/app.config';
import { SupportService } from '../interfaces/support';
import { RxRequestService } from '../../core/services/rx-request.service';

declare var Intercom: any;

declare var __INTERCOM_APP_ID__: string;

export class IntercomService extends SupportService {
  static deps = [AppConfig, RxRequestService];

  unreadCount$ = new Observable((subscriber: Subscriber<number>) => {
    execIfDefined('Intercom', () => {
      Intercom('onUnreadCountChange', (unreadCount: number) => {
        subscriber.next(unreadCount);
      });
    });
  });

  show(body?: string) {
    if (typeof __INTERCOM_APP_ID__ === 'undefined' || !__INTERCOM_APP_ID__) {
      window.open(this.supportLink, '_blank');

      return;
    }

    this._showIntercom(body);
  }

  private _showIntercom(body?: string) {
    execIfDefined('Intercom', () => {
      this._liveChatIsOpen$.next(true);

      if (body) {
        Intercom('showNewMessage', body);
        return;
      }

      Intercom('show');
    });
  }

  hide() {
    execIfDefined('Intercom', () => {
      this._liveChatIsOpen$.next(false);
      Intercom('hide');
    });
  }

  updateSupportServiceContext(initial: boolean) {
    execIfDefined('Intercom', () => {
      if (initial) {
        Intercom('boot', this.buildIntercomPayload());
      }
    });
  }

  buildIntercomPayload() {
    if (!this.user) {
      return undefined;
    }

    const user = this.user;

    const payload = {
      email: user.email
    };

    if (user.name !== user.email) {
      payload['name'] = user.name;
    }

    if (user.profileImage) {
      payload['avatar'] = {
        type: 'avatar',
        image_url: user.profileImage
      };
    }

    return payload;
  }

  resetSupportService() {
    execIfDefined('Intercom', () => {
      try {
        Intercom('shutdown');
        Intercom('boot');
      } catch (e) {
        // Calling intercom shutdown if intercom is not booted results in exception.
      }
    });
  }

  hideDefaultLauncher() {
    execIfDefined('Intercom', () => {
      Intercom('update', {
        hide_default_launcher: true,
        vertical_padding: 20,
        ...this.buildIntercomPayload()
      });
    });
  }

  showDefaultLauncher() {
    execIfDefined('Intercom', () => {
      Intercom('update', {
        hide_default_launcher: false,
        vertical_padding: 60,
        ...this.buildIntercomPayload()
      });
    });
  }
}
